import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";
import claims from "../../../gql/claims";
import { useQuery } from "@apollo/client";
import Pagination from "../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppTable from "../../../shared/AppTable";
import TableSkeletonLoader from "../../../common/TableLoading";

export default function PreAuthCommunicationList({ setTotslList }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [limit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  const getStatusStyles = (status) => {
    const s = status?.toLowerCase();
    if (s === "active") return { bg: "#dcfce7", text: "#15803d" };
    if (s === "complete" || s === "success")
      return { bg: "#dcfce7", text: "#15803d" };
    if (s === "error") return { bg: "#fee2e2", text: "#b91c1c" };
    if (s === "not-active") return { bg: "#f1f5f9", text: "#475569" };
    return { bg: "#fef9c3", text: "#854d0e" };
  };

  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(claims.CLAIMS_PREAUTH_COMMUNICATIONLIST, {
    variables: {
      input: {
        request_name: "preAuth",
        limit: limit,
        page: pageNo,
      },
    },
  });

  useEffect(() => {
    setTotslList(data?.listAllCommunications?.total);
  }, [data]);

  const onPageChange = (newPage) => {
    setPageNo(newPage);
    refetch({
      input: {
        request_name: "preAuth",
        limit: limit,
        page: newPage,
      },
    });
  };

  const formatDateTime = (time) => {
    if (!time) return "";
    const sanitizedTime = time.replace(/\s\+\d{4}$/, "");
    const dateTime = new Date(sanitizedTime);
    if (isNaN(dateTime)) return "Invalid date";
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${dateOnly}<br/> ${timeOnly}`;
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => pageNo * limit + index + 1 - limit,
    },
    {
      header: t("Status"),
      render: (row) => {
        if (!row?.status) return "---";
        const styles = getStatusStyles(row.status);
        return (
          <Chip
            label={row.status}
            size="small"
            sx={{
              backgroundColor: styles.bg,
              color: styles.text,
              fontWeight: "700",
              fontSize: "10px",
              borderRadius: "6px",
              textTransform: "uppercase",
              height: 20,
            }}
          />
        );
      },
    },
    {
      header: t("Patient Name"),
      render: (row) => (
        <span className="text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.patient_name}
        </span>
      ),
    },
    { header: t("Transaction ID"), field: "transaction_id" },
    {
      header: t("Category"),
      render: (row) => <span className="capitalize">{row?.category}</span>,
    },

    {
      header: t("Created At"),
      render: (row) => (
        <span
          className="text-[11px]"
          dangerouslySetInnerHTML={{ __html: formatDateTime(row?.created_at) }}
        />
      ),
    },
  ];

  return (
    <>
      <AppTable
        cellClassName="!py-0"
        columns={columns}
        data={data?.listAllCommunications?.data}
        loading={loading || dataLoading}
        onView={(row) =>
          navigate("/preauth/details", {
            state: { currentItem: row, tabToActive: "communications" },
          })
        }
        LoaderComponent={<TableSkeletonLoader columnCount={7} rowCount={6} />}
      />
      <div>
        <Pagination
          currentPage={pageNo}
          totalPages={data?.listAllCommunications?.pages}
          onPageChange={onPageChange}
        />
      </div>
    </>
  );
}
